import React from 'react';
import {
	DefaultButtonCompat as DefaultButton,
	DialogFooterCompat as DialogFooter,
	mergeStyles,
	ModalCompat as Modal,
	PrimaryButtonCompat as PrimaryButton,
	StackCompat as Stack,
	useTheme,
} from 'components/FluentUICompat';
import {useTranslation} from 'react-i18next';
import {GlobalAnnouncement} from 'types';
import {useStore} from 'react-context-hook';
import {useMarkAsReadGlobalAnnouncementMutation} from './hooks/myGlobalAnnouncements.generated';

export enum GlobalAnnouncementPopupState {
	Open,
	Closed,
}

export interface GlobalAnnouncementState {
	announcement?: GlobalAnnouncement;
	popupState: GlobalAnnouncementPopupState;
	refetch: boolean;
	initialPopupShown: boolean;
}

const GlobalAnnouncementPopup: React.FC = () => {
	const [state, setState] = useStore<GlobalAnnouncementState>(
		'globalAnnouncementPopup',
		{
			popupState: GlobalAnnouncementPopupState.Closed,
			announcement: undefined,
			refetch: false,
			initialPopupShown: false,
		},
	);
	const {announcement, popupState} = state;
	const [markAsReadGlobalAnnouncementMutation] =
		useMarkAsReadGlobalAnnouncementMutation();

	const {t} = useTranslation('features/globalannouncements', {
		keyPrefix: 'GlobalAnnouncementPopup',
	});
	const theme = useTheme();
	const dialogContentStyle = mergeStyles({
		backgroundColor: theme.palette.neutralLight,
		textAlign: 'left',
		padding: 10,
	});
	const onDismiss = () => {
		setState({...state, popupState: GlobalAnnouncementPopupState.Closed});
	};
	const onClickMarkAsRead = async () => {
		if (!announcement) {
			console.error(`Internal error: Announcement is missing!`);
			return;
		}
		await markAsReadGlobalAnnouncementMutation({
			variables: {
				input: {
					id: announcement.id,
				},
			},
		});
		setState({
			...state,
			popupState: GlobalAnnouncementPopupState.Closed,
			refetch: true,
		});
	};
	return (
		<Modal
			isOpen={popupState === GlobalAnnouncementPopupState.Open}
			isBlocking={false}
			onDismiss={onDismiss}
		>
			<Stack style={{margin: 10, maxWidth: '65vw', maxHeight: '85vh'}}>
				<Stack.Item align='center'>
					<h2>{announcement?.name || t('TitleMissing')}</h2>
				</Stack.Item>
				<Stack.Item>
					<div
						className={dialogContentStyle}
						dangerouslySetInnerHTML={{
							__html:
								announcement?.content || '<div>Message content missing</div>',
						}}
					/>
				</Stack.Item>
				<Stack.Item align='end' style={{marginLeft: 50}}>
					<DialogFooter>
						<PrimaryButton onClick={onClickMarkAsRead}>
							{t('MarkAsRead')}
						</PrimaryButton>
						<DefaultButton onClick={onDismiss} text={t('RemindAgain')} />
					</DialogFooter>
				</Stack.Item>
			</Stack>
		</Modal>
	);
};

export default GlobalAnnouncementPopup;
